import * as moment from 'moment'

const generateValuePeriodicite = (dureePlacement, periodicite) =>{
    if(dureePlacement && periodicite){
        switch(periodicite){
            case 'Annuelle':
                return dureePlacement*1;
            case 'Semestrielle':
                return dureePlacement*2;
            case 'Trimestrielle':
                return dureePlacement*4;
            case 'Bimestrielle':
                return dureePlacement*6;
            case 'Mensuelle':
                return dureePlacement*12;
            case 'In-fine':
                return 1;
            default:
                return 0;
        }
    } else {
        return 0
    }
}


export const cotationGlobalControl = (form, values) => {
    switch(form){
        case "AUTOCALL_RENDEMENT":
            return (
                    (values.seuilAutocall && values.barriereCoupon && parseFloat(values.seuilAutocall) <= parseFloat(values.barriereCoupon)) ||
                    (values.barriereCoupon && values.barriereProtectionCapital && parseFloat(values.barriereCoupon) < parseFloat(values.barriereProtectionCapital)) ||
                    (values.seuilAutocall && values.barriereProtectionCapital && parseFloat(values.seuilAutocall) < parseFloat(values.barriereProtectionCapital)) ||
                    (values.couponConditionnelMax && values.couponConditionnelMin && parseFloat(values.couponConditionnelMax) < parseFloat(values.couponConditionnelMin)) ||
                    (values.nombreDePeriodesCoupon !== undefined && values.dureePlacement !== undefined && values.periodicite !== undefined && values.nombreDePeriodesCoupon > generateValuePeriodicite(values.dureePlacement, values.periodicite)) ||
                    (values.couponGaranti && values.couponConditionnelMax && parseFloat(values.couponGaranti) < parseFloat(values.couponConditionnelMax))
                );
        case "CAP":
            return (values.dureeDeLaCouverture && values.dureeDuPretSousJacent && values.dureeDeLaCouverture <= values.dureeDuPretSousJacent);
        case "CAP_KO":
            return (values.dureeDeLaCouverture && values.dureeDuPretSousJacent && values.dureeDeLaCouverture <= values.dureeDuPretSousJacent);
        case "COLLAR":
            return (values.dureeDeLaCouverture && values.dureeDuPretSousJacent && values.dureeDeLaCouverture <= values.dureeDuPretSousJacent);
        case "COLLAR_KI_KO":
            return (values.dureeDeLaCouverture && values.dureeDuPretSousJacent && values.dureeDeLaCouverture <= values.dureeDuPretSousJacent);
        case "COLLAR_KO":
            return (values.dureeDeLaCouverture && values.dureeDuPretSousJacent && values.dureeDeLaCouverture <= values.dureeDuPretSousJacent);
        case "DIY_CHANGE":
            return (
                    (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                    (values.premier_fixing && values.dernier_fixing && moment(values.dernier_fixing).isBefore(values.premier_fixing)) ||
                    (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum)) 
                );
        case "DIY_PLACEMENT":
            return (
                    (values.seuil_autocall && values.barriere_de_protection_du_capital && parseFloat(values.seuil_autocall) < parseFloat(values.barriere_de_protection_du_capital)) ||
                    (values.seuil_autocall && values.barriere_de_coupon_conditionnel_minimum && parseFloat(values.seuil_autocall) < parseFloat(values.barriere_de_coupon_conditionnel_minimum)) ||
                    (values.barriere_de_coupon_conditionnel_minimum && values.barriere_de_protection_du_capital && parseFloat(values.barriere_de_coupon_conditionnel_minimum) <= parseFloat(values.barriere_de_protection_du_capital)) ||
                    (values.coupon_minimum && values.coupon_minimum && parseFloat(values.coupon_cible) <= parseFloat(values.coupon_minimum))
                );
        case "SWAP":
            return (values.dureeDeLaCouverture && values.dureeDuPretSousJacent && values.dureeDeLaCouverture <= values.dureeDuPretSousJacent);
        case "SWAP_KO":
            return (values.dureeDeLaCouverture && values.dureeDuPretSousJacent && values.dureeDeLaCouverture <= values.dureeDuPretSousJacent);
        case "TARF":
            return (
                    (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                    (values.premier_fixing && values.dernier_fixing && moment(values.dernier_fixing).isBefore(values.premier_fixing)) ||
                    (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum)) 
                );
        case "TERME_ASYMETRIQUE_DESACTIVANT":
            return (
                    (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                    (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum))
                );
        case "TERME_ASYMETRIQUE":
            return (
                    (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                    (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum)) 
                );
        case "TERME_PARTICIPATIF":
            return (
                    (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                    (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum))
                );
        case "TERME_SEC":
            return false;
        case "TUNNEL_ASYMETRIQUE":
            return (
                    (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                    (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum)) 
                );
        case "WEDDING_CAKE_ACCUMULATEUR":
            return (
                    (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                    (values.premier_fixing && values.dernier_fixing && moment(values.dernier_fixing).isBefore(values.premier_fixing)) ||
                    (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum))
                );
        case "WEDDING_CAKE_OPTIONS":
            return (
                    (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                    (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum)) 
                );
        case "TERME_ACCUMULATEUR_KO":
            return (
                        (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
                        (values.premier_fixing && values.dernier_fixing && moment(values.dernier_fixing).isBefore(values.premier_fixing)) ||
                        (values.montant_maximum && values.montant_minimum && parseFloat(values.montant_maximum) < parseFloat(values.montant_minimum))
                    );
        default:
            return false;
    }
}


// WEBPACK FOOTER //
// ./src/shared/Cotation/form/GlobalCondition.tsx